"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DENIED = exports.ALLOWED = exports.NOT_ALLOWED_TO_PLAY = exports.EMPTY_STRING = exports.X_CLIENT = exports.WEB = exports.Notification = exports.userDataLS = exports.userTokensLS = exports.authRefreshTokenLS = exports.authAccessTokenLS = exports.playerDefaultKey = exports.ImageExtension = exports.VIDEO_THUMBNAIL_SIZE = exports.PLAY_FROM_BEGINNING = exports.HTTP_METHOD = exports.CMS_PLATFORM_QUERY = exports.ROUTE = exports.CMS_CW_CARD_TEMPLATE = exports.CMS_STRUCTURE = exports.CMS_DETAILS_ITEM_TYPE = exports.CMS_ROUTE_DATA = exports.CMS = exports.FALLBACK_THEME = exports.DEFAULT_LANGUAGE = exports.PLATFORMS = exports.COLLECTIONS = void 0;
exports.COLLECTIONS = {
    ACCOUNTS: 'accounts',
    RESUME_WATCHING: 'resumeWatching',
    PROFILES: 'profiles',
    FAVORITES: 'favorites',
};
exports.PLATFORMS = {
    SMART_TV: 'TV',
    RESPONSIVE_WEB: 'RW',
};
exports.DEFAULT_LANGUAGE = 'en';
exports.FALLBACK_THEME = {
    BACKGROUND_FROM: '#0A0032',
    BACKGROUND_TO: '#150049',
    BACKGROUND_TYPE: 'gradient',
    DANGER: '#F94444',
    INFO: '#418DFF',
    NEUTRAL: '#FFFFFF',
    PRIMARY: '#0A0132',
    SECONDARY: '#281D56',
    SUCCESS: '#10AF46',
    TEXT_COLOR: '#FFFFFF',
    WARNING: '#F09814',
};
exports.CMS = {
    BASE_URL: '{baseUrl}',
    BASE_URL_PARSED: '{baseUrl}/parsed/',
    LANGUAGE: '{lang}',
    SLUG: '{slug}',
    PLATFORM: '?platform=',
    PRODUCT: '&product=',
    ASSET_TYPE: '{assetType}',
    RESOURCE_TYPE: '{resourcetype}',
    CODE: '{code}',
    PARENT_TYPE: '{parentType}',
    SEASON_INDEX: '{seasonIndex}',
    EPISODE_INDEX: '{episodeIndex}',
    COUNTRY: '&country=',
    FIRST_QP_COUNTRY: '?country=',
};
exports.CMS_ROUTE_DATA = {
    DETAILS: 'details',
    CATEGORY: 'category',
    CONFIG: 'config',
    VOCABULARY: 'vocabulary',
};
exports.CMS_DETAILS_ITEM_TYPE = {
    MOVIE: 'movie',
    SERIE: 'serie',
    VIDEO: 'video'
};
exports.CMS_STRUCTURE = {
    DETAILS: 'movie-details-page',
};
exports.CMS_CW_CARD_TEMPLATE = 'vel:cardtype:hcw';
exports.ROUTE = {
    PLAYER: '/player',
    SHORT: '/short',
};
exports.CMS_PLATFORM_QUERY = {
    TV: 'ctv',
    RW: 'web',
};
exports.HTTP_METHOD = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
};
exports.PLAY_FROM_BEGINNING = 0;
exports.VIDEO_THUMBNAIL_SIZE = 'ar_16:9,w_1920';
exports.ImageExtension = {
    JPG: 'jpg',
    PNG: 'png',
    WEBP: 'webp',
};
exports.playerDefaultKey = 'default-key';
exports.authAccessTokenLS = 'auth_access_token';
exports.authRefreshTokenLS = 'auth_refresh_token';
exports.userTokensLS = 'user_tokens';
exports.userDataLS = 'user_data';
exports.Notification = {
    LOGOUT_USER: 'LOGOUT_USER',
};
exports.WEB = 'web';
exports.X_CLIENT = 'x-client';
exports.EMPTY_STRING = '';
exports.NOT_ALLOWED_TO_PLAY = 'You are not allowed to play';
exports.ALLOWED = 'allowed';
exports.DENIED = 'denied';
